import { render, staticRenderFns } from "./FechamentoSubmenu.vue?vue&type=template&id=c57774a8"
import script from "./FechamentoSubmenu.vue?vue&type=script&lang=js"
export * from "./FechamentoSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports